module.exports = __webpack_public_path__ + "static/media/twitter-mobile-1.13920eea.svg";